import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ChipInput from 'material-ui-chip-input'
import CustomSelect from "../Select";
import {Grid, Typography} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {removeItemFromArray, superSplit} from "../../utils/functions";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {ThemeProvider} from "@material-ui/styles";
import Info from '@material-ui/icons/Info';
import Tooltip from "@material-ui/core/Tooltip";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = theme => {
    return {
        card: {

        },
        cardSelected: {
            backgroundColor: '#98ea98',
        }
    }
}

const Theme = (borderRadius = '0 0 0 0') => createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: borderRadius,
            },
            input: {
                padding: '10px 14px',
            }
        },
        MuiInputLabel: {
            formControl: {
                top: '-12px',
                left: '10px'
            }
        },
        MuiDialogActions: {
            root: {
                justifyContent: 'center'
            }
        },
        MuiButton: {
            root: {
                borderRadius: borderRadius,
            },
            containedPrimary: {
                color: '#fff'
            },
            contained: {
                color: '#7a865d'
            }
        }
    },
    palette: {
        primary: {
            main: '#95c61c'
        },


    },
});

class SelectPlan extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: props.selected
        }

        this.handleClose = () => {
            this.setState({selected: null})
            this.props.onClose();
        };

        this.handleSuccess = () => {
            this.setState({selected: null})
            this.props.onSuccess(this.state.selected);
        }


    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.open !== this.props.open) {
            this.forceUpdate();
        }
        if (prevProps.selected !== this.props.selected) {
            this.setState({selected: this.props.selected});
        }
    }

    render() {
        let discount = this.props.discount
        let correctType = (this.props.user?.type === 'mail' && discount?.for_mail) || (this.props.user?.type === 'chat' && discount?.for_chat)

        return (
            <div>
                <Dialog fullWidth open={this.props.open} onClose={this.handleClose} aria-labelledby="form-dialog-title"
                        style={{textAlign: "center"}}>
                    <DialogTitle style={{backgroundColor: '#f9f9f9'}} id="form-dialog-title"><b>Выбор тарифного плана</b></DialogTitle>
                    <ThemeProvider theme={Theme('34px' || '0 0 0 0')}>
                        <DialogContent style={{textAlign: "center", marginBottom: '30px'}}>

                            {
                                this.props.plans.map(item => {
                                    let isSelected = item.id === this.state.selected
                                    let hasDiscount = correctType && ((item.type === 'admin' && discount?.is_admin) || (item.type === 'user' && discount?.is_user))
                                    return(

                                        <Card className={isSelected ? this.props.classes.cardSelected : this.props.classes.root} variant="outlined" onClick={() => this.setState({selected: item.id})}>
                                            <CardContent>

                                                <Typography align={"center"} variant="h5" component="h2">
                                                    НА {item.period} {item.period === 1 ? "ДЕНЬ" : "ДНЕЙ"}
                                                </Typography>
                                                <Typography align={"center"} variant={"h4"}>
                                                    {item.price / 100} UAH
                                                </Typography>
                                                {hasDiscount && <Typography align={'center'} variant={'h5'} color={"secondary"}>
                                                    {'-' + discount.discount_percent + '%' + ' (-' + (item.price * discount.discount_percent / 10000).toFixed(2) + ' UAH)'}
                                                </Typography>}
                                            </CardContent>
                                        </Card>

                                    );
                                })
                            }
                            <Card className={this.state.selected === null ? this.props.classes.cardSelected : this.props.classes.root} variant="outlined" onClick={() => this.setState({selected: null})}>
                                <CardContent>

                                    <Typography align={"center"} variant="h5" component="h2">
                                        НЕ ВЫБРАНО
                                    </Typography>

                                </CardContent>
                            </Card>
                        </DialogContent>
                        <DialogActions style={{marginBottom: '20px'}}>
                            <Button variant={'contained'} onClick={this.handleClose} color="default">
                                Отмена
                            </Button>
                            <Button variant={'contained'} onClick={() => {
                                this.handleSuccess();
                            }} color="primary">
                                Готово
                            </Button>
                        </DialogActions>
                    </ThemeProvider>
                </Dialog>
            </div>
        );
    }
}

export default withStyles(styles)(SelectPlan)